"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagRS = function FlagRS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-54.58-32.57h-50.85l-2.12-12.71h55.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-106-35.74l.53,3.17h50.85l.52-3.17Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd350"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "112.94",
    y: "48.06",
    width: "2.12",
    height: "8.48",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "110.82",
    y: "50.18",
    width: "6.35",
    height: "2.12",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-54.42-41a2,2,0,0,1-.72-.13,2.11,2.11,0,0,1-1.27-2.71l4.49-12.39a2.22,2.22,0,0,0-.15-1.85,1.93,1.93,0,0,0-1.29-1c-5.48-1.16-16.08-3.12-25.62-3.12h-2c-9.54,0-20.15,2-25.62,3.12a2,2,0,0,0-1.3,1,2.26,2.26,0,0,0-.14,1.85l4.48,12.39a2.11,2.11,0,0,1-1.27,2.71,2.12,2.12,0,0,1-2.71-1.27l-4.48-12.38a6.52,6.52,0,0,1,.41-5.36,6.21,6.21,0,0,1,4.12-3.07C-101.9-64.45-91-66.46-81-66.46h2c9.92,0,20.86,2,26.5,3.21a6.21,6.21,0,0,1,4.12,3.07,6.49,6.49,0,0,1,.42,5.36l-4.49,12.38a2.1,2.1,0,0,1-2,1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80-42.89A2.12,2.12,0,0,1-82.12-45V-62.23A2.11,2.11,0,0,1-80-64.34a2.11,2.11,0,0,1,2.12,2.11V-45A2.12,2.12,0,0,1-80-42.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.35-41a2.18,2.18,0,0,1-.44,0,2.12,2.12,0,0,1-1.64-2.51L-64.86-56a4.26,4.26,0,0,0-.49-3.28c-2.94-1.08-8.83-3-14.07-3h-1.17c-5.25,0-11.14,1.9-14.19,3A4.82,4.82,0,0,0-95.16-56l2.57,12.38a2.11,2.11,0,0,1-1.64,2.5,2.11,2.11,0,0,1-2.5-1.64l-2.58-12.38c-.63-3.09.35-7,3-8,4.05-1.51,10.06-3.3,15.67-3.3h1.17c5.61,0,11.61,1.79,15.66,3.29,2.7,1,3.69,5,3,8.06l-2.57,12.38A2.12,2.12,0,0,1-65.35-41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-107-42.1h54l.53-3.18h-55.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd350"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-120.26-32.57a2.12,2.12,0,0,0-2.12,2.12v74A42.45,42.45,0,0,0-80,86.08,42.46,42.46,0,0,0-37.63,43.54v-74a2.12,2.12,0,0,0-2.12-2.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-75.77,37.35l4.24-10.59L-80,28.88l-8.47-2.12,4.24,10.59-10.6,36A29.33,29.33,0,0,0-80,77.61a29.26,29.26,0,0,0,14.82-4.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.35,45.89l-3.74.93L-90.87,32-94.57,30l-10,18h-9.35v4.24h4.56l-5.88,4.7,2.65,3.31,5-4-2,5.9,4,1.34,3.87-11.61L-94.32,50Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.84-11.38l-9.67-4.83A4.25,4.25,0,0,1-106.73-21l.55-2.19a2.41,2.41,0,0,0-2.33-3,2.39,2.39,0,0,0-1.88.91,35.32,35.32,0,0,0-7.75,22.09v44.8s8.84-1.77,16.83-13.4a8.37,8.37,0,0,1,6.46-3.53l-4.22,12.69,8.47,2.12,7.42-8.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-64.66,45.89l3.73.93L-69.15,32-65.44,30l10,18h9.35v4.24h-4.55l5.87,4.7-2.64,3.31-5-4,2,5.9-4,1.34-3.86-11.61L-65.69,50Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.18-11.38l9.68-4.83A4.25,4.25,0,0,0-53.29-21l-.55-2.19a2.41,2.41,0,0,1,2.34-3,2.36,2.36,0,0,1,1.87.91A35.33,35.33,0,0,1-41.87-3.21v44.8s-8.85-1.77-16.84-13.4a8.36,8.36,0,0,0-6.46-3.53l4.23,12.69-8.47,2.12-7.42-8.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-92.72-26.21h-10.59l3.18,4.24,7.41,2.11L-97-17.73h6.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-67.3-26.21h10.6L-59.88-22l-7.42,2.11,4.24,2.13h-6.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.81-27.87l-10,1.66L-80-17.73l-4.24-8.48-10-1.66a1.41,1.41,0,0,0-1.5,2l5.11,10.22-4.24,4.24h29.66l-4.23-4.24,5.1-10.22a1.41,1.41,0,0,0-1.5-2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.83-44.35A3.18,3.18,0,0,1-80-41.17a3.18,3.18,0,0,1-3.18-3.18A3.18,3.18,0,0,1-80-47.53a3.18,3.18,0,0,1,3.18,3.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-77.54-36.77c0,1-1.12,1.77-2.51,1.77s-2.51-.79-2.51-1.77,1.13-1.76,2.51-1.76,2.51.79,2.51,1.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-90.07-36.77c0,1-1.13,1.77-2.52,1.77s-2.5-.79-2.5-1.77,1.12-1.76,2.5-1.76,2.52.79,2.52,1.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-102.61-36.77c0,1-1.12,1.77-2.51,1.77s-2.51-.79-2.51-1.77,1.12-1.76,2.51-1.76,2.51.79,2.51,1.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-52.47-36.77c0,1-1.13,1.77-2.51,1.77s-2.52-.79-2.52-1.77,1.13-1.76,2.52-1.76,2.51.79,2.51,1.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65-36.77c0,1-1.12,1.77-2.51,1.77S-70-35.79-70-36.77s1.12-1.76,2.51-1.76,2.51.79,2.51,1.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.1-44.35a3.18,3.18,0,0,1-3.18,3.18,3.18,3.18,0,0,1-3.18-3.18,3.18,3.18,0,0,1,3.18-3.18,3.18,3.18,0,0,1,3.18,3.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.49-44.35a3.17,3.17,0,0,1-3.17,3.18,3.18,3.18,0,0,1-3.18-3.18,3.18,3.18,0,0,1,3.18-3.18,3.17,3.17,0,0,1,3.17,3.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-91.54-44.35a3.17,3.17,0,0,1-3.17,3.18,3.18,3.18,0,0,1-3.18-3.18,3.18,3.18,0,0,1,3.18-3.18,3.17,3.17,0,0,1,3.17,3.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-103.16-44.35a3.18,3.18,0,0,1-3.18,3.18,3.17,3.17,0,0,1-3.17-3.18,3.17,3.17,0,0,1,3.17-3.18,3.18,3.18,0,0,1,3.18,3.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.36-62.23a4.11,4.11,0,0,0,.59-2.11A4.24,4.24,0,0,0-80-68.58a4.24,4.24,0,0,0-4.24,4.24,4.21,4.21,0,0,0,.59,2.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80,32.05A15.9,15.9,0,0,1-95.9,16.16v-28.6h31.78v28.6A15.9,15.9,0,0,1-80,32.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.18-11.38V16.16A14.82,14.82,0,0,1-80,31,14.82,14.82,0,0,1-94.84,16.16V-11.38h29.66m2.12-2.12H-97V16.16A17,17,0,0,0-80,33.11a17,17,0,0,0,17-16.95Zm0,0",
    transform: "translate(194 123)",
    fill: "#a54b50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.18,30.64A14.39,14.39,0,0,0-80,31a14.48,14.48,0,0,0,3.18-.35v-42h-6.36s0,42,0,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "99.16",
    y: "129.1",
    width: "29.66",
    height: "6.36",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagRS;
exports["default"] = _default;